export enum PaymentMethod {
  ClearingAccount = 'CLEARING',
  Debit = 'DEBIT',
  ReferenceAccount = 'REFERENCE',
  Voucher = 'VOUCHER',
  Wire = 'WIRE',
}
